import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.to-string.js";
import { getAuthorityListAll } from '@/api/authority';
export var authority = {
  namespaced: true,
  state: {
    isInit: 0,
    authorityMap: {}
  },
  mutations: {
    setAuthorityMap: function setAuthorityMap(state, authorityMap) {
      state.isInit = 1;
      state.authorityMap = authorityMap;
    }
  },
  actions: {
    getAuthorityMap: function getAuthorityMap(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, state, res, authorityMap;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              if (!(state.isInit == 0)) {
                _context.next = 7;
                break;
              }
              _context.next = 4;
              return getAuthorityListAll();
            case 4:
              res = _context.sent;
              console.log("res校色", res);
              if (res.code == 0) {
                authorityMap = {};
                res.data.list.forEach(function (val) {
                  authorityMap[val.authorityId.toString()] = val.authorityName;
                });
                // dictionaryMap[res.data.resysDictionary.type] = dict
                commit("setAuthorityMap", authorityMap);
                // return state.dictionaryMap[type]
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  getters: {
    getAuthorityMap: function getAuthorityMap(state) {
      return state.authorityMap;
    }
  }
};